import { render } from "./video-element.vue?vue&type=template&id=01a24248"
import script from "./video-element.vue?vue&type=script&lang=js"
export * from "./video-element.vue?vue&type=script&lang=js"

import "./video-element.vue?vue&type=style&index=0&id=01a24248&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__